module.exports = __webpack_public_path__ + "img/headerImg.650db3a5.png";